// extracted by mini-css-extract-plugin
module.exports = {"container":"MainContainer_container__2XARH"};